import React from 'react';

import { Button, Card, Typography } from 'antd';

import { constants } from 'helpers/constants';

const SalesPageUrls = () => {
  return (
    <Card className='mt-5 max-w-full'>
      <div className='flex flex-col gap-3'>
        <Typography.Title level={4} className='mb-0!'>
          Crie sua página com Orbit Pages!
        </Typography.Title>
        <Typography.Paragraph className='text-content-subtitle mb-0!'>
          Clientes Eduzz tem 3 páginas grátis! Clique no botão abaixo para começar.
        </Typography.Paragraph>
        <div>
          <Button type='primary' href={constants.links.OrbitPage} target='_blank' rel='noopener noreferrer'>
            Criar minhas páginas - É grátis!
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default SalesPageUrls;
